module.exports = __webpack_public_path__ + "img/role4.a8a78927.gif";